/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {MessageFilter} from "../ui/messages/Page_Messages";
import {MultiSelectDropDown} from "../../../widgets/MultiSelectDropdown";

type Props = {
    updateMessageFilter: (messageFilter: MessageFilter) => void,
    selectedMessageFilter: MessageFilter | undefined
}

export function SelectMessageStatus(props: Props) {
    const options = [
        {label: "All Messages", value: MessageFilter.ALL, checked: props.selectedMessageFilter === MessageFilter.ALL},
        {label: "Unread Messages", value: MessageFilter.UNREAD, checked: props.selectedMessageFilter === MessageFilter.UNREAD},
        {label: "No Reply", value: MessageFilter.NO_REPLY, checked: props.selectedMessageFilter === MessageFilter.NO_REPLY}
    ];
    return <div className={"ll_h_c"}>
        <MultiSelectDropDown
            labels={{main: "Status"}}
            options={options}
            onItemClick={value => {
                props.updateMessageFilter(value);
            }}
        />
    </div>;
}
